module.exports = __webpack_public_path__ + "img/Seite26-papa.eca40c1f.png";